import { isObject } from "lodash";
import { FileExtension } from "types/file";

export const getBaseAPIUrl = () => {
  let locationInfo = window.location;
  const { host, hostname } = locationInfo;
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "vndev.hanbiro.com" ||
    hostname === "global3.hanbiro.com"
  ) {
    return "https://vndev.hanbiro.com/dasanbooks/public/api";
  } else {
    return "https://gw.dasanbooks.com/manuscript/cms/public/api";
  }
};

export const getBaseUrl = (defaultHost: String = "") => {
  let locationInfo = window.location;
  const { host, hostname } = locationInfo;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      const baseUrlArr = process.env.REACT_APP_BASE_URL?.split("/");
      if (baseUrlArr) {
        return "https://" + baseUrlArr?.[2];
      } else {
        return "https://vndev.hanbiro.com";
      }
    }
  } else {
    const data = defaultHost
      ? defaultHost
      : localStorage.getItem("host") || host;
    const dataArr = data?.split("/");
    return "https://" + dataArr?.[0];
  }
};

export const getBaseHost = (defaultHost: String = "") => {
  let data = defaultHost ?? localStorage.getItem("host");
  return "https://" + data;
};

export const getGroupwareUrl = () => {
  let locationInfo = window.location;
  const { hostname } = locationInfo;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return process.env.REACT_APP_BASE_URL;
    } else {
      return getBaseHost("vndev.hanbiro.com") + "/ngw";
    }
  } else {
    if (window.location !== window.parent.location) {
      locationInfo = window.parent.location;
    }
    const { hostname, protocol } = locationInfo;
    const absPath = "/ngw";
    let apiUrl = [protocol, "//", hostname, absPath].join("");

    return apiUrl;
  }
};

export const keyStringify = (
  data: { [key: string]: any },
  preKey: string = ""
): { [key: string]: any } => {
  let newData: { [key: string]: any } = {};

  for (const i in data) {
    if (isObject(data[i])) {
      newData = { ...newData, ...keyStringify(data[i], i) };
    } else {
      newData[preKey ? `${preKey}.${i}` : i] = data[i];
    }
  }

  return newData;
};

export const getUserAvatarUrl = (
  cn: string | number | undefined,
  no: string | number | undefined,
  width = 35,
  height = 35,
  userLatestModified = 0,
  isThumbnail = false
) => {
  return isThumbnail
    ? getGroupwareUrl() +
        `/org/user/photo/no/${no}/cn/${cn}/thumb/1?t=${userLatestModified}`
    : getGroupwareUrl() +
        `/org/user/photo/no/${no}/cn/${cn}?width=${width}&height=${height}&t=${userLatestModified}`;
};

export const getFileExtension = (name: string): FileExtension => {
  const extension = name.split(".").pop()?.toLocaleLowerCase() as FileExtension;
  return extension || "";
};

export const checkIsLoadedInIframe = () => {
  return window !== window.parent;
};
